import { AdditionalInfoSetting, AdditionalObject } from '@/libs/llc/database/additional-info';
import { isGoodContrastRatio } from '../../utility/color';

export type PropertyUsecase = 'space' | 'event' | 'goods';

export function isPropertyUsecase(value: unknown): value is PropertyUsecase {
  return value === 'space' || value === 'event' || value === 'goods';
}

const DEFAULT_USECASE = 'space';

export function getPropertyUsecase(property: any): PropertyUsecase {
  if (property) {
    const { usecase } = property;
    if (isPropertyUsecase(usecase)) {
      return usecase;
    }
  }
  return DEFAULT_USECASE;
}

const PRODUCT_LABELS: { [key in PropertyUsecase]: string } = {
  space: 'スペース',
  event: 'イベント',
  goods: '商品',
};

export function getProductLabel(property: any) {
  const usecase = getPropertyUsecase(property);
  return PRODUCT_LABELS[usecase];
}

const DEFAULT_COLOR = '#f44336';

export function getColor(property: any) {
  const { color } = property || {};
  return color || DEFAULT_COLOR;
}
export function getColors(property: any) {
  const { color = '#f08300' } = property || {};
  const sub = isGoodContrastRatio(color, '#ffffff') ? '#ffffff' : '#000000';
  return [color, sub];
}

const EMPTY_ADDITIONAL_OBJECT: AdditionalObject = {
  numOfPeople: false,
  name: false,
  nameRuby: false,
  address: false,
  gender: false,
  telephone: false,
  email: false,
  additonalEmail: false,
  birthDay: false,
  memo: false,
  expantion: false,
};

export function getAdditionalObject(settings: AdditionalInfoSetting[]): AdditionalObject {
  return settings.reduce((obj, key) => ({ ...obj, [key]: true }), EMPTY_ADDITIONAL_OBJECT);
}
